var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrev = function SvgPrev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.83 67.037"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 33054"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a2a2a2",
    fillRule: "evenodd",
    d: "M0 33.564 33.564 0l1.266 1.357L2.624 33.564 34.83 65.771l-1.267 1.267Z",
    "data-name": "Path 44402"
  }))));
};
export default SvgPrev;